
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FullTextPdfEventPayload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FullTextPdfEventPayload"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullTextPdfUri"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":81}};
    doc.loc.source = {"body":"fragment FullTextPdfEventPayload on FullTextPdfEventPayload {\n  fullTextPdfUri\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
